import type { WorkmateScene } from '@/components/ui/workmate-loader';

export function workmateSceneForPath(pathname: string): WorkmateScene {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.includes('approvals')) return 'approvals';
  if (parts.includes('team')) return 'team';
  if (parts.some((part) => /^(?:invoice|invoices|contractor-invoices)$/.test(part)))
    return 'invoices';
  if (
    parts.some((part) =>
      /^(?:shift|shifts|my-shifts|available-shifts|create-shift|edit-shift|import-shifts|recurring-series|job|jobs|create-job|edit-job|availability)$/.test(
        part,
      ),
    )
  )
    return 'shifts';
  return 'juggling';
}
